// extracted by mini-css-extract-plugin
export var activityContainer = "_nv-0";
export var typingIndicatorContainer = "_nv-1";
export var typingIndicatorDot = "_nv-2";
export var wave = "_nv-3";